<app-organization-ui
  [organizationsState]="organizationsState$ | async"
  (submitClick)="submit($event)"
></app-organization-ui>
